export default __webpack_public_path__ + "static/media/line-chart.6aee20e5.svg";